import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/shutterstock_1919883236-min.jpg")